import React, { useEffect, useState } from 'react'
import { HeaderProps } from './Header.types'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { GENERAL_STORE, ROUTING_STORE } from 'store'
import { withAlert } from 'react-alert'
import { isShotWizardPageOpened, isTimelineTagsPageOpened } from 'utilities'
import { Profile } from './Profile'
import { Notifications } from './Notifications'
import { Header as HeaderUI } from '@touche-lts/panel-ui/dist'

const HeaderComponent = (props: HeaderProps) => {
  const {
    className,
    style,
    [ROUTING_STORE]: {
      location: { pathname },
      push,
      goBack
    },
    [GENERAL_STORE]: {
      alert: { counter, type, message }
    },
    alert
  } = props

  const [alertCounter, setAlertCounter] = useState<number>(counter)

  useEffect(() => {
    const gotNewAlert = alertCounter < counter
    if (gotNewAlert) {
      setAlertCounter(counter)
      alert[type](message)
    }
  }, [counter, alertCounter, alert, message, type])

  const showBackButton =
    isShotWizardPageOpened(pathname) || isTimelineTagsPageOpened(pathname)

  return (
    <HeaderUI
      className={className}
      style={ { minWidth: '320px' } } // Set style for minimal width
      onLogoClick={() => push('/')}
      showBackButton={showBackButton}
      onBackButtonClick={goBack}
      notificationsComponent={Notifications}
      profileComponent={Profile as any}
    />
  )
}

const Header = withAlert()(
  inject(GENERAL_STORE, ROUTING_STORE)(observer(HeaderComponent))
)
export { Header }
